import { inject } from 'vue'
import { storeToRefs } from 'pinia'
import { createI18n as I18n } from 'vue-i18n'
import enGB from './translations/en-GB.json'
import frFR from './translations/fr-FR.json'
import nlNL from './translations/nl-NL.json'
import deDE from './translations/de-DE.json'
import itIT from './translations/it-IT.json'
import available from './translations/available'
import regex_keys from './translations/regex_keys'
import { useClientStore } from '@/stores/ClientStore'
import { get as _get, mapValues as _mapValues } from 'lodash'

const locale = 'en-GB'
const i18nSymbol = Symbol()

const i18n = I18n({
  locale,
  fallbackLocale: 'en-GB',
  messages: {
    'en-GB': enGB,
    'fr-FR': frFR,
    'nl-NL': nlNL,
    'de-DE': deDE,
    'it-IT': itIT
  }
})

i18n.global.translate = function (obj, locale = i18n.global.locale) {
  if (!obj) return false
  if (typeof obj === 'string') return obj
  if (typeof obj === 'object') {
    if (obj[locale]) return obj[locale]

    const { getClientFromState } = storeToRefs(useClientStore())
    const default_locale = getClientFromState.value.active_languages.find(language => obj[language])

    return obj[default_locale]
  }
}

i18n.global.interpolate = function (key, obj = {}) {
  const text = i18n.global.translate(key)
  const regex = /%%([a-z.-_]+)%%/g

  return text.replace(regex, (match, path) => _get(obj, path, path))
}

i18n.global.plural = function (key, count, obj = {}) {
  if (!key) return

  const [singular, plural] = i18n.global.translate(key).split(' | ')

  return i18n.global.interpolate(!plural || count === 1 ? singular : plural, obj)
}

i18n.global.getKey = function (key) {
  const match = Object.keys(regex_keys).find(k => key.match(k))

  if (match) key = regex_keys[match]

  return key
}

i18n.global.getLocalesTranslations = function (key) {
  return _mapValues(available, ({ id }) => key ? i18n.global.t(key, {}, { locale: id }) : null)
}

i18n.global.getCurrentLanguage = function () {
  return Object.values(available).find(lang => lang.id === i18n.global.locale)
}

i18n.global.getLocale = function () {
  return i18n.global.locale
}

export default i18n.global

export const createI18n = {
  install: function (app) {
    app.use(i18n)
    app.provide(i18nSymbol, i18n.global)
  }
}

export function useI18n () {
  return inject(i18nSymbol)
}
